<div class="optGroup-dropdown-container" [ngClass]="{
    'hvac-input-min-label': minimizeLabel,
    'optGroup-dropdown-primary': variant==='primary',
    'optGroup-dropdown-small': size === 'small',
    'optGroup-dropdown-no-shadow': shadow === 'none',
    'optGroup-dropdown-light-shadow': shadow === 'light',
    'optGroup-dropdown-multiple': multiple,
    'hvac-open': isOpen,
    'hvac-disabled': disabled
}" [formGroup]="group" (hvacClickOutside)="handleClick(true)">
    <label *ngIf="valueText?.length === 0" [attr.for]="selectId" class="hvac-input-label">{{ defaultOption }}<abbr *ngIf="required" title="required" class="optGroup-dropdown-label-required">{{ required ? '*' : ''}}</abbr></label>
    <select [attr.required]="required || null" [formControlName]="control" class="optGroup-dropdown-control" [attr.id]="selectId" [multiple]="multiple ? 'multiple': null" [attr.disabled]="disabled ? 'disabled' : null">
        <optgroup class="optGroup-dropdown-parent" *ngFor="let parentGroup of options" [label]="parentGroup.parent" (click)="handleOptGroupClick($event)">
            <option class="optGroup-dropdown-control-option" *ngIf="placeholder" [ngValue]="defaultEmptyVal">{{ placeholder }}</option>
            <option class="optGroup-dropdown-control-option" *ngFor="let child of parentGroup.children" [value]="child">{{ child.name }}</option>
        </optgroup>
    </select>

    <div class="optGroup-dropdown-mask" [ngClass]="{ 'optGroup-dropdown-error': error }" (click)="handleClick()">
        <span class="optGroup-dropdown-mask-text" [ngClass]="{'optGroup-dropdown-mask-text-disbaled': disabled}">{{ valueText }}</span>
        <utc-svg class="optGroup-dropdown-dropdown-icon" src="assets/icons/chevron-down.svg"></utc-svg>
    </div>
